import { render, staticRenderFns } from "./StatisticsCharts.vue?vue&type=template&id=2b9864b2&scoped=true&"
import script from "./StatisticsCharts.vue?vue&type=script&lang=js&"
export * from "./StatisticsCharts.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsCharts.vue?vue&type=style&index=0&id=2b9864b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9864b2",
  null
  
)

export default component.exports